// ── PALETTE E STILI TEMPLATE ──────────────────────────────────────────────────

import { Palette, PdfTemplate } from './pdf-types';

export const PALETTES: Record<PdfTemplate, Palette> = {
  default: {
    pageBg: [252, 248, 243],
    accent: [180, 145, 85],
    dark: [35, 30, 25],
    mid: [100, 90, 78],
    light: [165, 155, 140],
    border: [210, 190, 165],
  },
  ivory: {
    pageBg: [252, 248, 243],
    accent: [180, 145, 85],
    dark: [35, 30, 25],
    mid: [100, 90, 78],
    light: [165, 155, 140],
    border: [210, 190, 165],
  },
  blanc: {
    pageBg: [255, 255, 255],
    accent: [20, 20, 20],
    dark: [15, 15, 15],
    mid: [100, 100, 100],
    light: [170, 170, 170],
    border: [200, 200, 200],
  },
  blush: {
    pageBg: [255, 255, 255],
    accent: [185, 115, 105],
    dark: [40, 30, 30],
    mid: [130, 100, 95],
    light: [190, 160, 155],
    border: [220, 190, 185],
  },
  noir: {
    pageBg: [18, 15, 12],
    accent: [210, 170, 95],
    dark: [235, 225, 210],
    mid: [165, 150, 128],
    light: [100, 90, 75],
    border: [65, 55, 40],
  },
};

// Titoli sezioni per lingua
export const SECTION_TITLES: Record<string, Record<string, string>> = {
  between: {
    it: 'Tra',
    en: 'Between',
    both: 'Between / Tra',
  },
  effective_date: {
    it: 'Data di Efficacia',
    en: 'Effective Date',
    both: 'Effective Date / Data di Efficacia',
  },
  services: {
    it: 'Servizi',
    en: 'Services',
    both: 'Services / Servizi',
  },
  oggetto: {
    it: 'Oggetto del Contratto',
    en: 'Subject of Agreement',
    both: 'Subject / Oggetto del Contratto',
  },
  location: {
    it: 'Requisiti Location',
    en: 'Location Requirements',
    both: 'Location Requirements / Requisiti',
  },
  pagamento: {
    it: 'Termini di Pagamento',
    en: 'Payment Terms',
    both: 'Payment Terms / Termini di Pagamento',
  },
  cancellazione: {
    it: 'Termini di Cancellazione',
    en: 'Cancellation Terms',
    both: 'Cancellation Terms / Termini di Cancellazione',
  },
  clausole_aggiuntive: {
    it: 'Clausole Aggiuntive',
    en: 'Additional Clauses',
    both: 'Additional Clauses / Clausole Aggiuntive',
  },
  chiusura: {
    it: 'Disposizioni Finali',
    en: 'Final Provisions',
    both: 'Final Provisions / Disposizioni Finali',
  },
  wedding_day: {
    it: 'Giorno del Matrimonio',
    en: 'Wedding Day',
    both: 'Wedding Day / Giorno del Matrimonio',
  },
  signatures: {
    it: 'Firme',
    en: 'Signatures',
    both: 'Signatures / Firme',
  },
};

export function getSectionTitle(key: string, lang: string): string {
  const titles = SECTION_TITLES[key];
  if (!titles) return key;
  if (lang === 'it') return titles['it'] ?? key;
  if (lang === 'en') return titles['en'] ?? key;
  return titles['both'] ?? key;
}
